import React, { useState } from "react";
import logo from "../images/icons/logo_white.webp";
import bars from "../images/icons/bars.png";
import close from "../images/icons/close.png";
const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);

  const toggleMenu = () => {
    setIsMobile(!isMobile);
  };

  const LogoComponent = ({ hideOnDesktop = false }) => (
    <li className={`logo-container ${hideOnDesktop ? "hide-on-desktop" : ""}`}>
      <img className="logo" src={logo} alt="rodo tea logo in white" />
    </li>
  );
  return (
    <nav className="navbar">
      <LogoComponent hideOnDesktop={true} />
      <ul className={`nav-links ${isMobile ? "mobile" : ""}`}>
        <li>
          <a href="/">Home</a>
        </li>
        <li>
          <a href="/about">About</a>
        </li>
        <LogoComponent />
        <li>
          <a href="/services">Services</a>
        </li>
        <li>
          <a href="/contact">Contact</a>
        </li>
      </ul>
      <div className="menu-icon" onClick={toggleMenu}>
        <img src={`${isMobile ? close : bars}`} alt="menu" />
      </div>
    </nav>
  );
};

export default Navbar;
